export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7105.b6491ca1.jpg";